import TableRow from "./TableRow";
import TableRowPlaceholder from "./TableRowPlaceholder";
import TableRowError from "./TableRowError";
import { useTranslation } from "react-i18next";

function TableBody({
  tableName,
  columns,
  rows,
  rowsPerPage,
  emptyRowHeight,
  rowHeight,
  loading,
  error,
  actions,
  internalOrderFields,
  hasSapDownloadButtons,
  hasSapConfirmButtons,
  highlightedRows,
  highlightedRowColors,
}) {
  const { t } = useTranslation("Shared");
  return (
    <tbody>
      {error && (
        <TableRowError
          columns={columns}
          emptyRowHeight={emptyRowHeight}
          rowHeight={rowHeight}
          error={error}
        />
      )}
      {loading &&
        Array.from({ length: rowsPerPage }, (_, i) => ({
          id: i + 1,
        })).map((_, idx) => (
          <TableRowPlaceholder
            key={idx}
            tableName={tableName}
            idx={idx}
            rowHeight={rowHeight}
            columns={columns}
          />
        ))}
      {!error && !loading && !rows.length && (
        <tr className="text-center align-middle" style={{ height: rowHeight }}>
          <td colSpan={columns.length}>{t("queue.no_records_to_display")}</td>
        </tr>
      )}
      {!error &&
        !loading &&
        rows?.map((row, index, array) => (
          <TableRow
            key={index}
            tableName={tableName}
            index={index}
            columns={columns}
            row={row}
            actions={actions}
            internalOrderFields={internalOrderFields}
            hasSapDownloadButtons={hasSapDownloadButtons}
            hasSapConfirmButtons={hasSapConfirmButtons}
            array={array}
            highlightedRows={highlightedRows}
            highlightedRowColors={highlightedRowColors}
          />
        ))}
      <tr style={{ height: emptyRowHeight }} />
    </tbody>
  );
}

export default TableBody;
